export const MediaImageSliderData = [
    {
        imageUrl: '/assets/images/decorations/media/media_sidr_in_action_event_2.webp',
        imageAltText: 'Made For Royalty',
        videoUrl : '/assets/video/media_sidr_in_action_event_2_clip.mp4',
        videoUrlWebm : '/assets/video/media_sidr_in_action_event_2_clip.webm',
        hoverTitle: 'Made For Royalty'
    },
    {
        imageUrl: '/assets/images/decorations/media/media_sidr_in_action_event_3.webp',
        imageAltText: 'Decorating Urban Garden',
    },
    {
        imageUrl: '/assets/images/decorations/media/media_sidr_in_action_event_1.webp',
        imageAltText: 'Grab a Sapling and Let\'s Hiking',
    },
]
